module.exports = __webpack_public_path__ + "static/media/mitra.7f044534.png";